import { useCallback, useEffect, useState } from 'react';

export const useFormField = <T>({
  initialValue,
  validation,
  validateOnChange = false,
}: {
  initialValue: T;
  validation?: (value: T, ...args: unknown[]) => boolean;
  validateOnChange?: boolean;
}) => {
  const [value, setValue] = useState<T>(initialValue);
  const [isValid, setIsValid] = useState(true);

  const triggerValidation = useCallback(
    (...args: unknown[]) => {
      if (validation) {
        setIsValid(validation(value, ...args));
      }
    },
    [value, validation],
  );

  const checkValidation = useCallback(
    () => (validation ? validation(value) : true),
    [value, validation],
  );

  useEffect(() => {
    if (validateOnChange && value !== null) {
      triggerValidation();
    }
  }, [value, validateOnChange, triggerValidation]);

  return {
    value,
    changeValue: setValue,
    isValid,
    triggerValidation,
    checkValidation,
  };
};
